<script setup lang="ts">
/**
 * The lines under a chart: a `footnote` on how far the figures reach (set in
 * italics — „counted only within the page limit“) and the producer's `note`.
 * Renders nothing while both are empty.
 */
defineProps<{
  footnote?: string;
  note?: string;
}>();
</script>

<template>
  <p v-if="footnote" class="nx-chart-notes is-footnote" data-testid="nx-chart-footnote">
    {{ footnote }}
  </p>
  <p v-if="note" class="nx-chart-notes" data-testid="nx-chart-note">{{ note }}</p>
</template>

<style scoped>
.nx-chart-notes {
  flex: 0 0 auto;
  margin: 0;
  color: var(--nxt-fg-muted);
  font-size: var(--nxt-font-size-xs);
  line-height: var(--nxt-line-height-normal);
}
.nx-chart-notes.is-footnote {
  font-style: italic;
}
</style>
